
import {CLEANING_PLAN_SUCCESS} from "../../reducers/cleaningPlanReducer";


export const getCleaningPlanSuccess = (cleaningPlan) =>{
    return {
        type: CLEANING_PLAN_SUCCESS,
        payload: {cleaningPlan}
    }
}